import Details from "../components/Details";
import {useParams} from 'react-router-dom';
import React from 'react'

const CampDetail = () => {

  const {id} = useParams();
  
  console.log(id);
  return (
    <div>  
      <Details id={id}/>
    </div>
  )
}

export default CampDetail;
